<template>
    <form @submit.prevent="showConfirm = true">
        <button class="button button--blank">
            <IconBin fill="red" />
        </button>
        <ConfirmModal
            v-if="showConfirm"
            title="Remove worker from order"
            ok-label="Remove"
            @confirmed="removeWorker"
            @canceled="showConfirm = false"
        >
            <template #content>
                <Spinner v-if="loading" />
                <TransitionExpand v-if="error">
                    <ErrorList :error="error" />
                </TransitionExpand>
            </template>
        </ConfirmModal>
    </form>
</template>

<script>
import { IconBin } from '@speechki-frontend/shared/ui/icons';
import { ConfirmModal } from '@speechki-frontend/shared/ui/modals';
import TransitionExpand from '@speechki-frontend/shared/ui/TransitionExpand';
import { ErrorList } from '@speechki-frontend/shared/ui/forms';
import Spinner from '@speechki-frontend/shared/ui/Spinner';

import { removeWorkerFromOrder } from '../../api/workers';

export default {
    name: 'OrderManageWorkersDelete',
    components: {
        IconBin,
        ConfirmModal,
        TransitionExpand,
        ErrorList,
        Spinner,
    },
    props: {
        orderId: {
            type: [Number, String],
            required: true,
        },
        worker: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            showConfirm: false,
            loading: false,
            error: null,
        };
    },

    methods: {
        async removeWorker() {
            try {
                this.loading = true;
                this.error = null;

                await removeWorkerFromOrder(this.orderId, this.worker.id);

                this.showConfirm = false;
                this.$emit('remove', this.worker);
            } catch (e) {
                this.error = e;
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>
